<div *ngIf="data.type === 'duplicateVan'">
    <h2 style="color:red">Duplicate Van</h2>
    <div class="vanModalDetailText">
        Your last van number <span class="dupVanNumberDisplay">{{data.lastVanUsed}}</span>
        is being used by another active user (<span class="dupVanDriverDisplay">{{data.vanInUseBy}}</span>).
        <br><br>
        Please select a different van or contact the coordinator to continue.
    </div>
    <div class="vanSelect">
        <label>Van Selection:</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Van Number</mat-label>
            <mat-select [(value)]="selectedVan">
                <mat-option *ngFor="let van of data.vanList"
                [value]="van.vanId"
                [disabled]="van.driverId !== ''">
                    {{van.vanId}} - {{van.driverName === '' ? 'Available' : van.driverName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="vanModalDetailText">
        Incomplete tasks that were assigned when you logged out, will be reassigned if they are available.
    </div>
    <div class="form-button-rows-wrap">
        <button type="button"  [disabled]="selectedVan === null || processing === true" class="continue-button" mat-raised-button (click)="saveProfile()">
            <span>{{processing === true ? 'Processing...' : 'Continue'}}</span>
        </button>
    </div>
</div>


<div *ngIf="data.type === 'lastVanUsed'">
    <h2>Welcome to CVV</h2>
    <div class="vanModalDetailText">
        The last van that you used is indicated below. You can continue with this van or change to another van.
    </div>
    <div class="vanSelect">
        <label>Van Selection:</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Van Number</mat-label>
            <mat-select [(value)]="selectedVan">
                <mat-option *ngFor="let van of data.vanList"
                [value]="van.vanId"
                [disabled]="(van.driverId !== '' && data.lastVanUsed !== van.vanId) ? true : false">
                    {{van.vanId}} - {{van.driverName === '' ? 'Available' : van.driverName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="vanModalDetailText">
        Any incomplete tasks that were assigned when you logged out, will be reassigned if they are available.
    </div>
    <div class="form-button-rows-wrap">
        <button type="button" [disabled]="selectedVan === null || processing === true" class="continue-button" mat-raised-button (click)="saveProfile()">
            <span>{{processing === true ? 'Processing...' : 'Continue'}}</span>
        </button>
    </div>
</div>


<!-- <div *ngIf="data.type === 'savedTasks'">
    <h2>Welcome to CVV</h2>
    <div class="vanModalDetailText">
       The last van that you used is indicated below. You can continue with this van or change to another van.
    </div>
    <div class="vanSelect">
        <label>Van Number</label><br>
        <select class="form-control" name="vanNumber" #vanNumber>
            <option *ngFor="let van of data.vanList"
            [selected]="data.lastVanUsed === van.vanId"
            [disabled]="van.driverId !== '' && data.lastVanUsed !== van.vanId ? true : false">
                {{van.vanId}} - {{van.driverName === '' ? 'Available' : van.driverName}}
            </option>
        </select>
    </div>
    <div class="aline"></div>
    <div class="row">
        <div class="col-12">
            <label>Keep Previous Assignments? </label>
            <div class="vanModalDetailText">At your last logout, you had assigned tasks that have not been cancelled or picked up by other drivers. Do you wish to keep these tasks?</div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
             <div class="form-button-rows-wrap">
                <button type="button" class="unassign-button" mat-raised-button (click)="unassignSavedTasks()">
                    <span>Unassign Tasks</span>
                    <i class="icon-minus-circle-white-inline minus-icon"></i>
                  </button>
                <button mat-flat-button color="primary" type="button" (click)="keepSavedTasks()">
                    <span>Keep Tasks</span>
                    <i class="icon-tasks"></i>
                </button>
              </div>
        </div>
    </div>
</div> -->
